<p class="search-host--title" translate="search-page.taste-of-the-town"></p>
<p class="search-host--subtitle" translate="search-page.best-offerings"></p>

<div class="search-host--router-outlet">
  <restaurants></restaurants>
</div>

<p class="search-host--more-action" (click)="actionClicked.emit('foodanddrink')"><em>{{ 'search-page.more-restaurants' | translate }}</em></p>
